import React from "react";
import "../css/WelcomeSection.css";
import { Link } from "react-router-dom";
const WelcomeSection = () => {
  return (
    <section className="welcome-section">
      <div className="welcome-container">
        {}
        <div className="welcome-content">
          <h1 className="welcome-title">
            Welcome to{" "}
            <span className="brand-name">Sahara Public Secondary School</span>
          </h1>
                   
          <p className="welcome-text">
            About Sahara Public Secondary School: We, at Sahara Public Secondary
            School, don't just give students an education and experiences that
            set them up for success in a career. We help them succeed in their
            career—to discover a field they're passionate about and dare to lead
            it. Education develops the personality of the students, molds their
            character, and develops mental skills to help them cope with
            problems and challenges. Our students are guided by qualified
            teachers and scholars who, in their own way, are also counselors and
            an inspiration. In our school, education is designed on a
            broad-based curriculum with the goal to ignite our nation's young
            minds. We believe in creating an environment where students also
            learn from their peers and through friendship.
          </p>
          <button className="btn btn-primary" type="button">
            <Link to="/about">Read more</Link>
          </button>
        </div>

        {}
        <div className="welcome-poster-wrapper">
          <div className="poster-card">
            <img
              src="../images/i.jpeg"
              alt="Noida Global School Admission Open Banner"
              className="poster-image"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default WelcomeSection;
